import SupplierAppConnectionList from './SupplierAppConnectionList'

export default SupplierAppConnectionList
